'use client';

import { DropdownMenu } from '@common/components';

import type { DonationBusinessSort } from '../../_hooks/useIntegratedSearchFilter';

const DONATION_SORT_LABELS: Record<DonationBusinessSort, string> = {
  LATEST: '최신 등록순',
  AMOUNT_DESC: '모금액 많은순',
  DEADLINE_ASC: '종료 임박순',
  RATE_DESC: '모금율 높은순',
  SUPPORT_DESC: '응원 많은순',
};

const DONATION_SORT_OPTIONS = (
  Object.keys(DONATION_SORT_LABELS) as DonationBusinessSort[]
).map((value) => ({ value, label: DONATION_SORT_LABELS[value] }));

interface DonationSortDropdownProps {
  sort: DonationBusinessSort;
  onSortChange: (sort: DonationBusinessSort) => void;
}

export function DonationSortDropdown({
  sort,
  onSortChange,
}: DonationSortDropdownProps) {
  return (
    <DropdownMenu
      type="text"
      align="end"
      options={DONATION_SORT_OPTIONS}
      value={sort}
      onChange={onSortChange}
      contentClassName="min-w-160"
    />
  );
}
